import { queryKey } from '../constants/queryClientKey';
import { createDepartment, deleteDepartment, getDepartments } from '../apis/department.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { updateDepartment } from '../apis/department.api';

export function useGetDepartments(
  params: Parameters<typeof getDepartments>[0],
  options?: UseQueryOptions
) {
  return useQuery([queryKey.department, sortObjectKeys(params)], () => getDepartments(params), {
    keepPreviousData: true,
    ...options,
  }) as UseQueryResult<Awaited<ReturnType<typeof getDepartments>>>;
}

export function useCreateDepartment() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createDepartment>[0]) => createDepartment(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.department]);
      },
      onError: (err) => {
        console.error('useCreateDepartment:', err);
      },
    }
  );
}

export function useUpdateDepartment() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: Parameters<typeof updateDepartment>[1] }) =>
      updateDepartment(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.department]);
      },

      onError: (err) => {
        console.error('useUpdateDepartment:', err);
      },
    }
  );
}

export function useDeleteDepartment() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteDepartment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.department]);
    },
    onError: (err) => {
      console.error('useDeleteDepartment:', err);
    },
  });
}
